export function getRoundedValue(val, digit) {
  const value = parseFloat(val);
  return Math.round(value * Math.pow(10, digit)) / Math.pow(10, digit);
}
